/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 *
 * ENConfig
 */

module.exports =
  process.env.NODE_ENV === 'production'
    ? require('./ENConfig')
    : require('./ENConfig.local');
